export * from './dados-assinaturas.component';